import authentication from "./authenticationReducer";
import language from "./languageReducer";
import userSettings from "./userSettingsReducer";
import identity from "./identityReducer";
import exportConfig from "./exportConfigReducer";

export default {
    authentication,
    language,
    userSettings,
    identity,
    exportConfig
};